import { inject, Injectable } from '@angular/core';
import {Utils} from '../utils/amplify-utils';
import { Product} from '../amplify/data-resource';
import { AmplifyService } from './amplify.service';
import { ApiService } from '../utils/api/api-service';

@Injectable({
  providedIn: 'root'
})

export class StoreService {
  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();

    private api = inject(ApiService);
  
  public async loadAllProducts(): Promise<Product[]> {
    //nexttoken / pagination ??????
    const response = await this.amplifyClient.models.Product.list(
    );
    const productList = Utils.getDataFromResult(response.data, response.errors, 'Product.list');
    if(!productList){
      return [];
    }else{
      return productList;
    }
  }

    public async fakePurchase(offerId:string){
      await this.api.call('confirmfaketransaction', { offerId });
    }

}

